export default "__VITE_ASSET__De0EVtV5__"